import { FC, memo, useReducer } from "react";
import { FaDownload } from "react-icons/fa";
import { CircularProgress, Grid, ListItem } from '@mui/material';
import { connect } from "react-redux";
import { downloadFile } from "./store/ViewDocumentItems";
import { Skeleton } from "../../dumb/Skeleton";

type Dictionary = {
    documentTemplateName: string;
    documentUrl: string;
};

export interface ViewDocumentItemsProps {
    documents: Dictionary[];
    downloadFile_d: (url: string, onCompletedCallback?: (res: any) => void) => void,
    showLoading?: boolean;
}

const ViewDocumentItems: FC<ViewDocumentItemsProps> = ({ documents, downloadFile_d, showLoading = false }) => {

    const [loading, updateLoading] = useReducer((state: any[], action: { type: string; id: any; }) => {
        if (action.type === 'add') {
            return [...state, action.id]
        } else if (action.type === 'remove') {
            return state.filter((id: any) => id !== action.id)
        }

        return state;
    }, [])

    const generateDocumentsList = (docs: any[], loading: any[]) => {
        let elements: any[] = [];

        docs.forEach((document, index) => {
            elements.push(
                <div className="pb-doc-row" key={"documentId" + index}>
                    <span className="pb-doc-name">{document?.documentTemplateName}</span>
                    <button
                        type="button"
                        className="pb-btn pb-btn-primary pb-doc-view"
                        disabled={loading.includes(document.documentUrl)}
                        onClick={() => {
                            updateLoading({ type: 'add', id: document.documentUrl })
                            setTimeout(() => {
                                handleViewDocument(document.documentUrl, () => {
                                    updateLoading({ type: 'remove', id: document.documentUrl })
                                })
                            }, 50)
                        }}>
                        {loading.includes(document.documentUrl) ? <CircularProgress size={18} style={{ color: "#fff" }} /> : <><FaDownload /> View</>}
                    </button>
                </div>
            );
        })

        return elements;
    }

    const handleViewDocument = (url: string, onCompletedCallback?: () => void) => {
        downloadFile_d(url, (response: any) => {
            if (response) {
                response.blob().then((blob: Blob | MediaSource) => {
                    const fileURL = URL.createObjectURL(blob);
                    window.open(fileURL, '_blank', 'noreferrer');
                });
            }
            onCompletedCallback?.();
        })
    }

    return <>
        {
            showLoading ? (
                <>
                    <Skeleton animation="wave" variant="text" component="h3" width="100%" />
                    <Skeleton animation="wave" variant="text" component="h3" width="100%" />
                    <Skeleton animation="wave" variant="text" component="h3" width="100%" />
                </>
            ) : (
                <>
                    {
                        documents instanceof Array && documents?.length > 0 ?
                            <div className="pb-docs">
                                {generateDocumentsList(documents, loading)}
                            </div>
                            : (
                                <h5
                                    className="mb-2 text-black"
                                    style={{ whiteSpace: 'pre-wrap' }}>
                                    {"No Documents"}
                                </h5>
                            )
                    }
                </>
            )
        }
    </>
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        downloadFile_d: (url: any, onCompletedCallback?: (res: any) => void) => dispatch(downloadFile(url, onCompletedCallback)),
    }
}

export default connect(null, mapDispatchToProps)(memo(ViewDocumentItems));